module.exports =(function() {
  return function(context) {
    return (function() {
      var $c, $e, $o;
      $e = function(text, escape) {
        return ("" + text).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/'/g, '&#39;').replace(/\//g, '&#47;').replace(/"/g, '&quot;');
      };
      $c = function(text) {
        switch (text) {
          case null:
          case void 0:
            return '';
          case true:
          case false:
            return '' + text;
          default:
            return text;
        }
      };
      $o = [];
      $o.push("<td class='asset-name' data-title='Name'>\n  <div class='column-inner-wrapper'>\n    <div class='avatar-presenter medium'>\n      <div class='avatar-wrapper square'>\n        <img class='avatar' src='" + ($e($c(this.asset.get("thumb")))) + "' rel='" + ($e($c(this.asset.get("url")))) + "'>\n      </div>\n      <div class='presenter-wrapper'>\n        <div class='asset-filename asset-link' notranslate>");
      $o.push("          " + $e($c(this.asset.get("title"))));
      $o.push("        </div>\n      </div>\n    </div>\n  </div>\n</td>\n<td class='dimensions' data-title='Dimensions' notranslate>\n  <div class='column-inner-wrapper'>\n    <div>");
      $o.push("      " + $e($c(this.asset.get("width"))));
      $o.push("      x");
      $o.push("      " + $e($c(this.asset.get("height"))));
      $o.push("    </div>\n  </div>\n</td>");
      if (this.asset.isMediaLibraryAsset) {
        $o.push("<td class='asset-options dropdown-align-right dropdown-container'>\n  <div class='asset-dropdown-icon button dropdown-ellipsis-toggle small'></div>\n  <ul class='dropdown-selection'>\n    <li>\n      <a class='blank' href='/media/" + ($e($c(this.asset.get("asset_id")))) + "' target='_blank'>Details</a>\n    </li>\n  </ul>\n</td>");
      }
      return $o.join("\n").replace(/\s([\w-]+)='true'/mg, ' $1').replace(/\s([\w-]+)='false'/mg, '').replace(/\s(?:id|class)=(['"])(\1)/mg, "");
    }).call(context);
  };

}).call(this);



//////////////////
// WEBPACK FOOTER
// ./app/javascript/backbone/platform/templates/assets/picker_asset_list_view.js.hamlc
// module id = 1355
// module chunks = 17